module.exports = __webpack_public_path__ + "img/business3.1adeaa68.jpg";